import React, { Component } from 'react';
import { Run, RuleRunner } from '../Validation/RuleRunner'
import { required, minLength, regexMatch } from '../Validation/Rules';
import RegexValidator from '../Validation/RegexValidator';
import Config from "../../config"

export default class Coordinate extends Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      coordinate: props.coordinate,
      defaultCoordinate: props.defaultCoordinate,
      useBankName: props.useBankName,
      validationErrors: { },
    };

    // Fields to validate
    this.fieldValidation = [
      RuleRunner("address", "L'adresse", required, minLength(3)),
      RuleRunner("zipcode", "Le code postal", required, minLength(5), regexMatch(RegexValidator.frZipCode, "Le code postal est incorrect")),
      RuleRunner("city", "La ville", required,regexMatch(RegexValidator.beginWithText, "La ville est incorrecte")),
      RuleRunner("country", "Le pays", required,regexMatch(RegexValidator.textOnly, "Le pays est incorrect")),
    ];

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    if (this.state.useBankName) {
      this.fieldValidation.push(RuleRunner("bank_name", "Le nom", required));
    } else {
      this.fieldValidation.push(RuleRunner("name", "Le nom", required));
    }
  }

  handleChange(event) {
    var coord = this.state.coordinate;
    const name = event.target.name;
    
    // If value is equal to on thus the element is a checkbox
    // so we get the checked value
    let value = event.target.rawValue;

    if (value === null || value === undefined) {
      value = event.target.value;
    }

    if (value === "on") {
      value = event.target.checked
    }

    // Update the businessHour object
    coord[name] = value;

    this.setState({
      coordinate: coord
    });

    //this.checkForm();
  }

  checkForm() {
    var errors = Run(this.state.coordinate, this.fieldValidation);

    this.setState({
      validationErrors: errors
    });

    return Object.keys(errors).length === 0;
  }

  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  getObject() {
    return this.state;
  }

  renderBankName() {
    return (
        <div className="row">
          <div className="mycol-12">
            <div className="form-group">
              <label className="label" htmlFor="bank_name">Nom</label>
              <input id="bank_name" name="bank_name" type="text" placeholder="Nom" className={"textbox textbox-full textbox-program-"+Config.program.style}
                     onChange={this.handleChange}
                     defaultValue={this.state.coordinate.bank_name}
                     required
              />
              <span className="form-error">{this.errorFor("bank_name")}</span>
            </div>
          </div>
        </div>
    );
  }

  renderName() {
    return (
      <div className="row">
        <div className="mycol-12">
          <div className="form-group">
            <label className="label" htmlFor="name">Nom</label>
            <input id="name" name="name" type="text" placeholder="Nom" className={"textbox textbox-full textbox-program-"+Config.program.style}
              onChange={this.handleChange}
              defaultValue={this.getDefaultValue("name")}
              required
            />
            <span className="form-error">{this.errorFor("name")}</span>
          </div>
        </div>
      </div>
    );
  }

  getDefaultValue(strField){
    if (this.state.coordinate){
      if(this.state.coordinate[strField]){
        return this.state.coordinate[strField];
      }
    }
    if (this.state.defaultCoordinate){
      if(this.state.defaultCoordinate[strField]){
        this.state.coordinate[strField] = this.state.defaultCoordinate[strField];
        return this.state.defaultCoordinate[strField];
      }
    }
    return "";

  }

  render() {
    return (
      <div>
        
        { this.state.useBankName ? this.renderBankName() : this.renderName() }

        <div className="row">
          <div className="mycol-12">
            <div className="form-group">
              <label className="label" htmlFor="address">Adresse</label>
              <input id="address" name="address" type="text" placeholder="Adresse" className={"textbox textbox-full textbox-program-"+Config.program.style}
                onChange={this.handleChange}
                defaultValue={this.getDefaultValue("address")}
                required
              />
              <span className="form-error">{this.errorFor("address")}</span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="mycol-4">
            <div className="form-group">
              <label className="label" htmlFor="zipcode">Code postal</label>
              <input id="zipcode" name="zipcode" type="text" placeholder="Code postal" className={"textbox textbox-full textbox-program-"+Config.program.style}
                onChange={this.handleChange}
                defaultValue={this.getDefaultValue("zipcode")}
                required
              />
              <span className="form-error">{this.errorFor("zipcode")}</span>
            </div>
          </div>
          <div className="mycol-4">
            <div className="form-group">
              <label className="label" htmlFor="city">Ville</label>
              <input id="city" name="city" type="text" placeholder="Ville" className={"textbox textbox-full textbox-program-"+Config.program.style}
                onChange={this.handleChange}
                defaultValue={this.getDefaultValue("city")}
                required
              />
              <span className="form-error">{this.errorFor("city")}</span>
            </div>
          </div>
          <div className="mycol-4">
            <div className="form-group">
              <label className="label" htmlFor="country">Pays</label>
              <input id="country" name="country" type="text" placeholder="Pays" className={"textbox textbox-full textbox-program-"+Config.program.style}
                onChange={this.handleChange}
                defaultValue={this.getDefaultValue("country")}
                required
              />
              <span className="form-error">{this.errorFor("country")}</span>
            </div>
          </div>
        </div>           
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Forms/PersonCoordinate.js